<template>
  <div class="bottomVert" v-if="detailReseauxNumerique.listeFaces.length">
    <gmap-map
      class="infoBorder gmap"
      :center="{
        lat: detailReseauxNumerique.latitude,
        lng: detailReseauxNumerique.longitude
      }"
      :zoom="12"
      :options="{
        mapTypeControlOptions: mapType,
      }"
      ref="mapReseauxNumerique"
      @tilesloaded="initCarto">
      <gmap-marker
        v-for="(m, index) in detailReseauxNumerique.listeFaces"
        :key="index"
        :clickable="true"
        :position="{
          lat: m.latitude,
          lng: m.longitude
        }"
        @click="detailReseauxNumeriqueComplet = m, show = true"
        :icon="icon(detailReseauxNumerique.couleur, m)">
      </gmap-marker>
      <gmap-marker
        v-if="markerReseauxNumeriques.lat"
        :position="{
          lat: markerReseauxNumeriques.lat,
          lng: markerReseauxNumeriques.lng,
        }"
        :icon="markerReseauxNumeriques.icon">
      </gmap-marker>
    </gmap-map>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated slideInRight"
      leave-active-class="animated slideOutRight"
      :duration="300"
      v-on:after-enter="bg = true"
      v-on:after-leave="bg = false">
      <app-detail-reseaux-numerique-complet
        :bg="bg"
        :detailReseauxNumeriqueComplet="detailReseauxNumeriqueComplet"
        v-if="show"/>
    </transition>
  </div>
</template>

<script>
import { iconColorGetter, TAILLE_ICON_GRAND, TAILLE_ICON_PETIT } from '@/services/general/iconColorGetter';
import {
  MAP_TYPE_CONTROL_OPTIONS,
  STYLE_MAPS_POI_HIDDEN, MAP_TYPE_NAME,
} from '@/configurations/configurationCarto';
import filterLatLng from '@/services/general/gestionLatLng';
import detailReseauxNumeriqueComplet from './detailReseauxNumeriqueComplet';

export default {
  name: 'carteReseauxNumerique',
  components: {
    appDetailReseauxNumeriqueComplet: detailReseauxNumeriqueComplet,
  },
  props: ['detailReseauxNumerique', 'markerReseauxNumeriques'],
  data() {
    return {
      detailFace: {},
      show: false,
      colorIcon: '#c242f4',
      bg: false,
      isLoadOnce: false,
      mapType: MAP_TYPE_CONTROL_OPTIONS,
    };
  },
  methods: {
    async levelZoom() {
      const bounds = new google.maps.LatLngBounds();
      filterLatLng(this.detailReseauxNumerique.listeFaces);
      this.detailReseauxNumerique.listeFaces.forEach(m => {
        if (m.latitude !== 0 && m.longitude !== 0
        && m.latitude !== null && m.longitude !== null) {
          bounds.extend({ lat: m.latitude, lng: m.longitude });
        }
      });
      if (this.markerReseauxNumeriques !== undefined &&
      this.markerReseauxNumeriques.lat !== undefined) {
        bounds.extend({ lat: this.markerReseauxNumeriques.lat,
          lng: this.markerReseauxNumeriques.lng });
      }
      this.$refs.mapReseauxNumerique.fitBounds(bounds);
    },
    icon(color, face) {
      if (face.codeFormat === '4' || face.codeFormat === '3') {
        if (!color) return iconColorGetter(this.colorIcon, TAILLE_ICON_GRAND, face.azimut, true);
        return iconColorGetter(color, TAILLE_ICON_GRAND, face.azimut, true);
      }
      if (!color) return iconColorGetter(this.colorIcon, TAILLE_ICON_PETIT, face.azimut, true);
      return iconColorGetter(color, TAILLE_ICON_PETIT, face.azimut, true);
    },
    async initPoi() {
      const map = await this.$refs.mapReseauxNumerique.$mapPromise;
      const styleMap = new google.maps.StyledMapType(STYLE_MAPS_POI_HIDDEN, {
        name: MAP_TYPE_NAME,
      });
      map.mapTypes.set('styled_map', styleMap);
    },
    async initCarto() {
      if (!this.isLoadOnce) {
        await this.initPoi();
        if (this.detailReseauxNumerique.listeFaces.length) {
          await this.levelZoom();
        }
        this.isLoadOnce = true;
      }
    },
  },
  mounted() {
    if (this.detailReseauxNumerique.latitude === null
      || this.detailReseauxNumerique.longitude === null) {
      this.detailReseauxNumerique.latitude = 0;
      this.detailReseauxNumerique.longitude = 0;
    }
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxNumeriques/carteReseauxNumerique.vue